// src/utils/vin-validation.js
export const VIN_REGEX    = /^[A-HJ-NPR-Z0-9]{17}$/i;
export const EXT_ID_REGEX = /^\d+$/;

/** @returns {'vin' | 'externalId' | 'empty' | 'invalid'} */
export function detectInputType(value) {
  const v = (value || '').trim();
  if (!v) return 'empty';
  if (VIN_REGEX.test(v)) return 'vin';
  if (EXT_ID_REGEX.test(v)) return 'externalId';
  return 'invalid';
}
